// Generated counts — never hand-type track/prompt totals. Run
// `python backend/gen_vault_stats.py` after any track change.
import stats from "./vault_stats.json";

const fmt = (n) => n.toLocaleString("en-GB");

export const VAULT = {
  tracks: stats.tracks,
  prompts: stats.prompts,
  tracksFmt: fmt(stats.tracks),
  promptsFmt: fmt(stats.prompts),
  bundles: stats.bundles,
  newTracks30d: stats.new_track_count_30d,
  latestTrackOrder: stats.latest_track_order,
  price: stats.current_price_gbp,
  lastUpdated: stats.last_updated,
  // Marketing claim across every Stag Vault product (lifetime, monthly, bundles, Starter).
  // Manually maintained — verify against Stripe before each campaign.
  customersClaim: "250+",
};
